import { createRoot } from 'react-dom/client';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducer from './reducer/index';
import './index.css';
import { applySavedTextSize } from './main/textSize';
import { reloadOnStaleChunks } from './main/chunkReload';

///////////////////////////////////////////////
const store = createStore(reducer);
applySavedTextSize();
reloadOnStaleChunks();

if (process.env.NODE_ENV !== "development") {
  console.log = console.info = console.warn = console.error = console.debug = () => null;
  // console.info = console.warn = console.error = console.debug = () => { };
}

const container = document.getElementById('meetoor-company');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
